import md5 from 'js-md5';
export function sha1(str) {
    const buffer = new TextEncoder().encode(str);
    return crypto.subtle.digest('SHA-1', buffer).then(hash => {
      return Array.from(new Uint8Array(hash)).map(b => b.toString(16).padStart(2, '0')).join('');
    });
}

export const setItem = (key, value) => {
    if ( typeof value === "object" ) {
        JSON.stringify(value)
    }
    window.localStorage.setItem(key,value)
}

export const getItem = (key) => {
    const data = window.localStorage.getItem(key)
    try {
        return JSON.parse(data)
    } catch (e) {
        return data
    }
}

// 检查设备型号
export const checkPC = () => {
  // 获取设备信息
  var ua = navigator.userAgent.toLowerCase();
  // console.log(ua)
  // 判断是否是微信环境
  // var isWeixin = ua.indexOf('micromessenger') != -1;
  var isAndroid = ua.indexOf('android') != -1;
  var isiPhone = ua.indexOf('iphone') != -1;
  var isMobile = isAndroid || isiPhone
  // var isPC = win || mac
  if (isMobile) {
    return false
  }
  else {
    return true
  }
}

// 检查设备型号
export const checkIos = () => {
  // 获取设备信息
  var ua = navigator.userAgent.toLowerCase();
  // console.log(ua)
  // 判断是否是微信环境
  // var isWeixin = ua.indexOf('micromessenger') != -1;
  var isIos = ua.indexOf('ios') != -1;
  // var isPC = win || mac
  if (isIos) {
    return true
  }
  else {
    return false
  }
}

// 获取媒体资源
export const getMedia = (time,urlPath) => {
  let baseUrl = "https://devres.racoondigi.cn/"
  let authkey = 'waGj3j9CbK79sN3HUfDNMt'
  // let md5Str = md5.hex(authkey+time+urlPath)
  let md5Str = md5(authkey+time+urlPath)
  let result = baseUrl+time+"/"+md5Str+urlPath
  
  return result
}

export function formatTimeTwo(format) {
   
  var formateArr = ['Y', 'M', 'D', 'h', 'm', 's'];
  var returnArr = [];

  // var date = new Date(number * 1000);
  var date = new Date(Date.parse(new Date())+86400000);
  returnArr.push(date.getFullYear());
  returnArr.push(formatNumber(date.getMonth() + 1));
  returnArr.push(formatNumber(date.getDate()));

  returnArr.push(formatNumber(date.getHours()));
  returnArr.push(formatNumber(date.getMinutes()));
  returnArr.push(formatNumber(date.getSeconds()));

  for (var i in returnArr) {
      format = format.replace(formateArr[i], returnArr[i]);
  }
  return format;

  function formatNumber(n) {
    n = n.toString()
    return n[1] ? n : '0' + n
  }
}

export const throttle = (func, wait) => {
    let timeout = null;
    let lastExecutionTime = 0;

    return function(...args) {
        const context = this;
        const now = Date.now();

        const executeFunction = function() {
            lastExecutionTime = now;
            timeout = null;
            func.apply(context, args);
        };

        // 检查时间差是否已经超过设定的wait时间
        if (timeout) clearTimeout(timeout);

        if (now - lastExecutionTime >= wait) {
            executeFunction();
        } else {
            timeout = setTimeout(executeFunction, wait - (now - lastExecutionTime));
        }
    };
}

export const debounce = (func, wait) => {
    let timeout;
    return function(...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
    };
}